export const _en = {
    rule: {
        layer: {
            libelle: "Rule"
        },
        buttons: {
            add: {
                label: "Add a rule"
            },
            del: {
                label: "Delete a rule"
            }
        },
        dialog: {
            add: {
                title: "Add a new rule"
            }
        },
        deletedCheckBox: {
            label: "Display deleted data"
        }
    },
    ruleDivision: {
        layer: {
            libelle: "Division association",
            component: {
                placeholder: "Select a division",
                actionBarLabel: "Delete",
                associationButton: "Associate"
            }
        }
    }
};

export const _fr = {
    rule: {
        layer: {
            libelle: "Règle"
        },
        buttons: {
            add: {
                label: "Règle"
            },
            del: {
                label: "Règle"
            }
        },
        dialog: {
            add: {
                title: "Ajout d'une règle pour la catégorie de règle sélectionnée"
            }
        },
        deletedCheckBox: {
            label: "Afficher les données archivées"
        }
    },
    ruleDivision: {
        layer: {
            libelle: "Services",
            component: {
                placeholder: "Sélectionner un service",
                actionBarLabel: "Suppression",
                associationButton: "Associer"
            }
        }
    }
};